module.exports = __webpack_public_path__ + "static/media/my-info-menu-main-icon.5b748e45.svg";